import { CheckboxAlt, CheckboxProps, classNames, stopEvent, useCustomEvent } from '@fold-dev/core'
import React, { useMemo, useState } from 'react'
import { Priority } from './priority-button'

export type CheckProps = {
    id?: string
    priority?: Priority
    onCheck: (e) => void
    checked: boolean
    type?: 'milestone' | 'blocker' | 'task' | any
    iconProps?: any
} & CheckboxProps

export const Check = ({ id, priority, onCheck, checked, type, ...rest }: CheckProps) => {
    const [fauxCheck, setFauxCheck] = useState(false)
    const icon = useMemo(() => {
        if (!checked && type == 'milestone') return 'task-type:milestone'
        if (!checked && type == 'blocker') return 'task-type:blocker'
        return 'check'
    }, [type, checked])
    const className = classNames({
        'f-check': true,
        'f-row': true,
        'is-faux': fauxCheck,
        'is-checked': checked,
        'is-high': priority == 'high',
        'is-medium': priority == 'medium',
        'is-low': priority == 'low',
        'is-milestone': type == 'milestone',
        'is-blocker': type == 'blocker',
    })

    const handleFauxCheck = ({ detail }) => {
        if (detail.id == id) {
            setFauxCheck(true)
            setTimeout(() => setFauxCheck(false), 2000)
        }
    }

    const handleFauxUncheck = ({ detail }) => {
        if (detail.id == id) {
            setFauxCheck(false)
        }
    }

    useCustomEvent('faux-check', handleFauxCheck)
    useCustomEvent('faux-uncheck', handleFauxUncheck)

    return (
        <div
            onMouseDown={stopEvent}
            className={className}>
            <CheckboxAlt
                icon={icon}
                checked={checked || fauxCheck}
                iconProps={{ size: 'xs' }}
                {...rest}
                onChange={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    onCheck(!checked)
                }}
            />
        </div>
    )
}
